import React from 'react';
import { FiUsers, FiFileText } from 'react-icons/fi';

const Overview = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 p-4">
      <div className="bg-white p-6 rounded-lg shadow-md">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-500">Total Users</p>
            <h3 className="text-2xl font-bold">{stats.totalUsers}</h3>
          </div>
          <FiUsers className="text-3xl text-blue-500" />
        </div>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-md">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-500">Total Blogs</p>
            <h3 className="text-2xl font-bold">{stats.totalBlogs}</h3>
          </div>
          <FiFileText className="text-3xl text-green-500" />
        </div>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-md">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-500">Content Writers</p>
            <h3 className="text-2xl font-bold">{stats.totalContentWriters}</h3>
          </div>
          <FiUsers className="text-3xl text-purple-500" />
        </div>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-md">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-500">Recent Blogs</p>
            <h3 className="text-2xl font-bold">{stats.recentBlogs}</h3>
          </div>
          <FiFileText className="text-3xl text-orange-500" />
        </div>
      </div>
    </div>
  );
};

export default Overview;
